<template>
  <div class="container is-grid padding-left-0 padding-right-0-mobile">
    <div class="is-col-12-md">
      <h2>
        <strong>Your guide to being a<br class="show-br-mobile"/> Sun Hero</strong>
      </h2>
    </div>
    <div class="sun-hero-guide-row is-col-12-md">
      <SunheroThumbnailTile image="educator-full-curriculum.png" href="/pdf/Sun-Heroes-Program-Curriculum.pdf" title=""
                            target="_blank" link="Download the full<br />
          curriculum" :hasBorder="true"/>
      <SunheroThumbnailTile image="educator-k-4.png" href="/ppt/Sun-Heroes-Sample-Presentation-Deck-Grades-K-4.pptx"
                            title="" target="_self" link="Download sample<br />
          presentation for<br />
          Grades K–4" :hasBorder="true"/>
      <SunheroThumbnailTile image="educator_5-8.png" href="/ppt/Sun-Heroes-Sample-Presentation-Deck-Grades-5-8.pptx"
                            title="" target="_self" link="Download sample<br />
      presentation for<br />
      Grades 5–8" :hasBorder="true"/>
    </div>
  </div>
</template>
<script>
import SunheroThumbnailTile from './SunheroThumbnailTile.vue'

export default {
  name: 'SunHeroGuideRow',
  components: {
    SunheroThumbnailTile
  }
}
</script>
<style lang="less" scoped>
@import (reference) "~@/assets/css/variables.less";

.container {
  h2 {
    font-size: .clampedW(5, @md-bp, @large-bp) [ @result];
    color: @color-txt-blue;
    @media screen and (max-width: ~"@{mq-md-bp}em") {
      text-align: center;
      font-size: 22px;
    }
  }
}

.sun-hero-guide-row {
  display: flex;
  flex-flow: row nowrap;
  @media screen and (max-width: ~"@{mq-md-bp}em") {
    flex-wrap: wrap;
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
  }
}
</style>
